import { Link } from "react-router-dom";
import { featuredArticles } from "@/mocks/articles";

export default function HeroSection() {
  const mainArticle = featuredArticles[0];

  return (
    <section
      className="relative min-h-[600px] md:min-h-[720px] flex items-end pb-12 md:pb-20 overflow-hidden"
      aria-label="首页首屏"
    >
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20theater%20stage%20with%20red%20velvet%20curtains%20and%20spotlight%20beams%20cutting%20through%20darkness%2C%20celebrity%20scandal%20atmosphere%2C%20cinematic%20red%20and%20black%20lighting%2C%20high%20contrast%20editorial%20photography&width=1600&height=900&seq=hero-bg&orientation=landscape"
          alt="黑料吃瓜网首屏背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/70" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-8">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 items-end">
          {/* Left */}
          <div className="space-y-6">
            {/* Avatars */}
            <div className="flex items-center gap-3">
              <div className="flex -space-x-3">
                {featuredArticles.slice(0, 3).map((art, i) => (
                  <img
                    key={art.id}
                    src={art.authorAvatar}
                    alt={art.author}
                    className="w-10 h-10 rounded-full border-2 border-white object-cover"
                    style={{ zIndex: 3 - i }}
                  />
                ))}
              </div>
              <span className="text-white/80 text-sm">
                10万+ 瓜友实时在线
              </span>
            </div>

            {/* H1 */}
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-white leading-tight">
              黑料吃瓜网
              <br />
              <span className="font-light text-white/90">
                全网独家爆料
              </span>
            </h1>

            {/* CTA */}
            <Link
              to={`/article/${mainArticle.id}`}
              className="inline-flex items-center gap-2 bg-white text-foreground-900 px-6 py-3 rounded-full text-sm font-semibold hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              查看今日最大瓜
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          {/* Right - Summary */}
          <div className="hidden md:block">
            <p className="text-white/90 text-base md:text-lg leading-relaxed max-w-md ml-auto text-right">
              实时追踪网红明星塌房现场，每日大赛独家吃瓜爆料不打烊。作为黑料不打烊的核心门面，为你提供最新反差视频内幕与热门大瓜。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}